import {
  Action,
  createReducer,
  on
} from '@ngrx/store';
import { environment } from '../../environments/environment';
import { FirebaseCredential } from '../models/firebase/FirebaseCredential';
import { SMBrand } from '../models/SMBrand';
import { SMBrandOwner } from '../models/SMBrandOwner';
import { createBrandDataSuccess, createBrandOwnerDataSuccess, createBrandOwnerFirebaseAuthSuccess, loadAllBrandsDataSuccess, loadCurrentBrandDataSuccess, loadCurrentUserDataSuccess, loadCurrentUserSuccess, loadSemtIDSuccess, loadTempBrandData, loadTempBrandDataSuccess, loadTempBrandOwnerDataSuccess, loginSuccess, resetState, updateBrandDataSuccess, updateBrandOwnerData, updateBrandOwnerDataSuccess, updateTempBrandDataSuccess, uploadImageSuccess } from './actions';

export const APP_FEATURE_KEY = 'app'

export interface AppState {
  semtID: string;
  credential: FirebaseCredential;
  userData: SMBrandOwner;
  brandData: SMBrand;
  newBrandOwner: SMBrandOwner;
  newBrandOwnerCred: FirebaseCredential;
  newBrand: SMBrand;
  newFileUrl: string;
  allBrands: SMBrand[];
  tempBrandOwnerData: SMBrandOwner;
  tempBrandData: SMBrand;
}

export interface AppPartialState {
  readonly [APP_FEATURE_KEY]: AppState;
}

export const appInitialState: AppState = {
  semtID: environment.semtID,
  credential: null,
  userData: null,
  brandData: null,
  newBrandOwner: null,
  newBrandOwnerCred: null,
  newBrand: null,
  newFileUrl: null,
  allBrands: [],
  tempBrandOwnerData: null,
  tempBrandData: null
}

export const AppReducer = createReducer(
  appInitialState,

  on(resetState, (state, payload) => ({
    ...appInitialState
  })),

  on(loadSemtIDSuccess, (state, payload) => ({
    ...state,
    semtID: payload.semtID
  })),

  on(loginSuccess, (state, payload) => ({
    ...state,
    credential: payload.credential
  })),

  on(loadCurrentUserSuccess, (state, payload) => ({
    ...state,
    credential: payload.user
  })),

  on(loadCurrentUserDataSuccess, (state, payload) => ({
    ...state,
    userData: payload.userData,
    semtID: payload.userData.semtID
  })),

  on(loadCurrentBrandDataSuccess, (state, payload) => ({
    ...state,
    brandData: payload.brandData
  })),

  on(loadTempBrandDataSuccess, (state, payload) => ({
    ...state,
    tempBrandData: payload.brandData
  })),

  on(createBrandOwnerDataSuccess, (state, payload) => ({
    ...state,
    newBrandOwner: payload.brandOwner
  })),

  on(createBrandDataSuccess, (state, payload) => ({
    ...state,
    newBrand: payload.brand
  })),

  on(createBrandOwnerFirebaseAuthSuccess, (state, payload) => ({
    ...state,
    newBrandOwnerCred: payload.cred
  })),

  on(updateBrandOwnerDataSuccess, (state, payload) => ({
    ...state,
    userData: payload.brandOwner
  })),

  on(uploadImageSuccess, (state, payload) => ({
    ...state,
    newFileUrl: payload.filePath
  })),
  on(loadAllBrandsDataSuccess, (state, payload) => ({
    ...state,
    allBrands: payload.brandsData
  })),

  on(loadTempBrandOwnerDataSuccess, (state, payload) => ({
    ...state,
    tempBrandOwnerData: payload.brandOwnerData
  }))
);

export function appReducer(state: AppState | undefined, action: Action): AppState {
  return AppReducer(state, action);
}
